/**
 * @file: 清除不能识别的组件
 * @author: xiaolong.huang@dmall.com
 */

import * as StageStatus from '../stageStatus';

const shelfCubeNames: string[] = [
    'shelvesbuild-e-sketchpad',
    'shelvesbuild-e-shelves-box',
    'shelvesbuild-e-p-roof',
    'shelvesbuild-e-p-layer',
    'shelvesbuild-e-g-default',
    'shelvesbuild-e-p-dishrack',
    'shelvesbuild-e-p-beam'
];
const cabinetCubeNames: string[] = [
    'shelvesbuild-e-sketchpad',
    'shelvesbuild-e-shelves-freezer',
    'shelvesbuild-e-p-cabinet',
    'shelvesbuild-e-g-default'
];

function clearUndefinedCube(shelfData: JsonData): void {
    if (!StageStatus.isTopFace()) {
        deepClear(shelfData, shelfCubeNames);
        return;
    }

    deepClear(shelfData, cabinetCubeNames);
}

function deepClear(shelfData: JsonData, whiteList: string[]): void {
    for(let i: number = 0; i < shelfData.cubes.length; i++) {
        if (!whiteList.includes(shelfData.cubes[i].cubeName)) {
            shelfData.cubes.splice(i, 1);
            i--;
            continue;
        }

        if (shelfData.cubes[i].cubes && shelfData.cubes[i].cubes.length) {
            deepClear(shelfData.cubes[i], whiteList);
        }
    }
}

export {
    clearUndefinedCube
};
